import { Link } from "react-router-dom";
import MiniPollChart from "@/components/MiniPollChart";

const typeMeta = {
  essay: { label: "Editorial", accent: "text-neutral-900" },
  forum: { label: "Debate", accent: "text-neutral-900" },
  poll: { label: "Poll", accent: "text-neutral-900" },
  interview: { label: "Interview", accent: "text-neutral-900" },
};

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function PostCard({ post, variant = "default", labelOverride }) {
  const meta = typeMeta[post.type] || typeMeta.essay;
  const isLead = variant === "lead";
  const label = labelOverride || meta.label;

  return (
    <Link
      to={`/post/${post.id}`}
      data-testid={`post-card-${post.id}`}
      className={`block group border-black transition-colors last:border-b-0 last:pb-0 ${
        isLead ? "border-b pb-8" : "border-b pb-6"
      }`}
    >
      <div className="flex items-center gap-3 mono text-[10px] uppercase tracking-[0.25em]">
        <span className={meta.accent}>{label}</span>
        <span className="text-neutral-400">/</span>
        <span className="text-neutral-500">{formatDate(post.created_at)}</span>
      </div>
      <h3
        className={`serif font-medium tracking-tight leading-tight mt-3 group-hover:text-[#fc4707] transition-colors whitespace-pre-line ${
          isLead ? "text-4xl sm:text-5xl" : "text-2xl sm:text-3xl"
        }`}
      >
        {post.title}
      </h3>
      {post.summary && (
        <p className={`mt-3 text-neutral-700 leading-relaxed ${isLead ? "text-base sm:text-lg" : "text-sm sm:text-base"}`}>
          {post.summary}
        </p>
      )}
      {post.type === "poll" && <MiniPollChart post={post} />}
      <div className="mt-4 mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
        By {post.author?.name || "Anonymous"}
        {post.type === "forum" && ` · ${post.comment_count || 0} replies`}
        {post.type === "poll" && ` · ${post.poll_total_votes || 0} votes`}
      </div>
    </Link>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-50 text-amber-800 border-amber-300",
    approved: "bg-emerald-50 text-emerald-800 border-emerald-300",
    rejected: "bg-red-50 text-red-800 border-red-300",
  };
  return (
    <span className={`inline-block px-2 py-0.5 mono text-[10px] uppercase tracking-[0.2em] border ${map[status] || map.pending}`}>
      {status}
    </span>
  );
}
